const manualModalOpen = () => {
  const sizeGuideModal = document.querySelector('.size-guide');
  const sizeGuideBtns = document.querySelectorAll('.trigger-size-guide');

  if (sizeGuideModal) {
    sizeGuideBtns.forEach((sizeGuideBtn) => {
      sizeGuideBtn.addEventListener('click', () => {
        sizeGuideModal.classList.add('visible');
        // const sizeGuideCloseBtn = document.querySelector('.size-guide-modal-close');
      })
    });
  }
}

export default manualModalOpen
